export default __webpack_public_path__ + "static/media/sc38.6f6d8a2c.jpg";